export const categorieTitleDescription = (categoryName: string | undefined) => {
  return categoryName
    ? {
        title: `JobsHash.com - ${categoryName} — #1  Job board for ${categoryName} developers`,
        description: `Find your next tech job on JobsHash.com. Handpicked ${categoryName} Jobs for coders. Get a job in 5 minutes! (or less).`,
      }
    : null;
};
